import Excel from "exceljs";

export async function ExportStatToExcel(data) {
  const wb = new Excel.Workbook();
  wb.creator = "Anisen";
  activitiesProposedAndDone(wb, data);
  plannedExternalActivities(wb, data);
  residentsProposedAndDone(wb, data);
  wellBeingForResidents(wb, data);
  return await wb.xlsx.writeBuffer();
}

function activitiesProposedAndDone(wb, data) {
  const sheet = wb.addWorksheet("Activités proposées et réalisées");
  let rows = data.activities_proposed_and_done.map(d => [d.activity, d.proposed, d.done]);
  if (rows.length === 0) {
    rows = [["Pas de données"]];
  }
  sheet.addTable({
		name: "TableActivitiesProposedAndDone",
		ref: "A1",
		headerRow: true,
		columns: [
      { name: "Activité", filterButton: true },
      { name: "Proposée", },
      { name: "Réalisée", }
    ],
		rows,
	});
}

function plannedExternalActivities(wb, data) {
  const sheet = wb.addWorksheet("Activités planifiées");
  let rows = data.planned_external_activities.map(d => [
    d.id === null ? "PAT Games" : d.activity,
    d.total
  ]);
  if (rows.length === 0) {
    rows = [["Pas de données"]];
  }
  sheet.addTable({
		name: "TablePlannedExternalActivities",
		ref: "A1",
		headerRow: true,
		columns: [
      { name: "Activité", filterButton: true },
      { name: "Plannifié", }
    ],
		rows,
	});
}

function residentsProposedAndDone(wb, data) {
  const sheet = wb.addWorksheet("Taux de participation effectif");
  let rows = data.residents_proposed_and_done.map(d => [d.lastname, d.firstname, d.total, d.done]);
  if (rows.length === 0) {
    rows = [["Pas de données"]];
  }
  sheet.addTable({
		name: "TableResidentsProposedAndDone",
		ref: "A1",
		headerRow: true,
		columns: [
      { name: "Nom", filterButton: true },
      { name: "Prénom" },
      { name: "Proposé", },
      { name: "Réalisées", }
    ],
		rows,
	});
}

function wellBeingForResidents(wb, data) {
  const sheet = wb.addWorksheet("Taux de satisfaction");
  let rows = data.well_being_for_residents.map(d => [d.lastname, d.firstname, d.percent]);
  if (rows.length === 0) {
    rows = [["Pas de données"]];
  }
  sheet.addTable({
		name: "TableWellBeingForResidents",
		ref: "A1",
		headerRow: true,
		columns: [
      { name: "Nom", filterButton: true },
      { name: "Prénom", },
      { name: "Taux de satisfaction (%)", }
    ],
		rows,
	});
}